export default __webpack_public_path__ + "static/media/gitlabInsightsProject.0af3615d.png";